export default "__VITE_ASSET__BaKsXG9M__"